module.exports = __webpack_public_path__ + "static/sdm_icon-9dcff24ab6601c8ccf41088a4118d9b4.svg";